import { render, staticRenderFns } from "./cheliang.vue?vue&type=template&id=0b351250"
import script from "./cheliang.vue?vue&type=script&lang=js"
export * from "./cheliang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports